import * as React from 'react';

import { Listing } from './listing';
import { MessagingCard } from 'components/common/messaging-card/messaging-card';
import { ResultType } from 'constants/resultType';
import { PropertyTypeCarouselWrapper } from 'components/common/property-type-carousel';
import { UrgencySearchMessagingCard } from 'components/common/urgency-messaging-card';

export interface ResultProps {
  className: string;
  endDate: string;
  index: number;
  lazyLoadImg: boolean;
  loading: boolean;
  model: any;
  resultType: ResultType;
  startDate: string;
  setResultRef?: (ref: HTMLElement, index: number) => void;
}

export const Result = (props: ResultProps) => {
  const { resultType, ...rest } = props;

  let ResultComponent;

  switch (resultType) {
    case ResultType.MESSAGING:
      ResultComponent = MessagingCard;
      break;
    case ResultType.URGENCYMESSAGING:
      ResultComponent = UrgencySearchMessagingCard;
      break;
    case ResultType.CAROUSEL:
      ResultComponent = PropertyTypeCarouselWrapper;
      break;
    case ResultType.HOTEL:
    default:
      ResultComponent = Listing;
  }

  return <ResultComponent {...rest} />;
};
